import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const MENU = [
  ["/dashboard", "fa-tachometer", "Dashboard"],
  ["/profile", "fa-user", "My Profile", "active"],
  ["/Student-Report", "fa-users", "Students"],
  // ["/Staff_Report_Dashbord","fa-user-tie","Staff"],
  // ["/Student-Report","fa-building","Schools"],
];

export default function Profile() {
  const [open, setOpen] = useState(false);
  const [dark, setDark] = useState(
    () => localStorage.getItem("theme") === "dark"
  );
  const [edit, setEdit] = useState(false);

  const [p, setP] = useState({
    name: "Administrator",
    email: "admin@studentdarpan.in",
    phone: "+91 98765 43210",
    role: "Super Admin",
    school: "Integrated Student School Darpan",
    city: "Jaipur, Rajasthan",
    joiningDate: "12 Jan 2024",
  });

  const [t, setT] = useState(p);

  /* ---------- DARK MODE PERSIST ---------- */
  useEffect(() => {
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  const toggleDark = () => setDark((prev) => !prev);

  const ch = (e) => setT({ ...t, [e.target.name]: e.target.value });

  const save = () => {
    setP(t);
    setEdit(false);
  };

  const cancel = () => {
    setT(p);
    setEdit(false);
  };

  const handleLogout = () => {
    if (window.confirm("Pakka logout karna hai?")) {
      localStorage.clear();
      sessionStorage.clear();
      setOpen(false);
      window.location.href = "/";
    }
  };

  const F = ({ i, l, n, v, full, dis }) => (
    <div className="fld" style={full ? { gridColumn: "span 2" } : {}}>
      <i className={`fa ${i} fi`} />
      <div className="fb">
        <label>{l}</label>
        {edit && !dis ? (
          <input name={n} value={v} onChange={ch} className="fip" />
        ) : (
          <p>{v}</p>
        )}
      </div>
    </div>
  );

  return (
    <>
      <style>{`

/* =====================================================
   GLOBAL
===================================================== */

:root {
  --bg: #f4f7fb;
  --c: #fff;
  --tx: #163a59;
  --mu: #64748b;
  --bd: #e4ecf5;
  --b: #2563eb;
  --p: #7c3aed;
  --g: #10b981;
  --r: #ef4444;
  --sh: 0 8px 28px rgba(8,35,60,.08);
}

.dk {
  --bg: #0b1220;
  --c: #131c31;
  --tx: #e2e8f0;
  --mu: #94a3b8;
  --bd: #1f2b45;
  --sh: 0 8px 28px rgba(0,0,0,.4);
}

* {
  box-sizing: border-box;
  font-family: Inter, "Segoe UI", Arial, sans-serif;
}

html,
body,
#root {
  width: 100%;
  min-height: 100%;
  margin: 0;
}

body {
  overflow-x: hidden;
}

/* =====================================================
   MAIN WRAPPER
===================================================== */

.pw {
  width: 100%;
  min-height: 100vh;
  background: var(--bg);
  color: var(--tx);
  padding-bottom: 40px;
}

.lay {
  width: 100%;
  max-width: 1600px;
  min-height: 100vh;
  margin: 0 auto;
  padding: 22px 30px;
  display: flex;
  align-items: flex-start;
  gap: 22px;
}

/* =====================================================
   SIDEBAR
===================================================== */

.sb {
  position: sticky;
  top: 20px;

  width: 250px;
  min-width: 250px;
  flex: 0 0 250px;

  background: var(--c);
  border: 1px solid var(--bd);
  border-radius: 16px;
  padding: 16px 12px;

  box-shadow: var(--sh);

  display: flex;
  flex-direction: column;
}

.br {
  display: flex;
  align-items: center;
  gap: 11px;

  padding: 6px 8px 16px;
  margin-bottom: 10px;

  border-bottom: 1px solid var(--bd);
}

.bi {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, .12),
    rgba(124, 58, 237, .10)
  );

  border-radius: 11px;
  color: var(--b);
  font-size: 17px;
}

.br small {
  display: block;

  color: var(--b);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1.4px;
}

.br strong {
  font-size: 16px;
  font-weight: 800;
}

.mn {
  list-style: none;
  padding: 0;
  margin: 0;

  display: flex;
  flex-direction: column;
  gap: 3px;
}

.mn a {
  display: flex;
  align-items: center;
  gap: 14px;

  padding: 11px 14px;

  color: var(--tx);
  font-size: 14px;
  font-weight: 600;

  text-decoration: none;

  border-radius: 10px;
  border: 1px solid transparent;

  transition: .25s;
}

.mn a i {
  width: 20px;
  text-align: center;
  color: #4b5a6b;
}

.mn a:hover {
  background: #f8fafc;
  color: var(--b);
  transform: translateX(3px);
}

.mn a.active {
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, .10),
    rgba(124, 58, 237, .08)
  );

  color: var(--b);
  border-color: rgba(37, 99, 235, .15);
}

/* =====================================================
   RED SEPARATOR
===================================================== */

.dv {
  height: 2px;
  margin: 12px 4px;

  background: linear-gradient(
    90deg,
    transparent,
    var(--r),
    transparent
  );

  border-radius: 20px;
  opacity: .7;

  list-style: none;
}

/* =====================================================
   LOGOUT LINK
===================================================== */

.logout-link {
  color: #ef4444 !important;
  font-weight: 700 !important;
}

.logout-link i {
  color: #ef4444 !important;
}

.logout-link:hover {
  background: rgba(239, 68, 68, .10) !important;
  color: #dc2626 !important;
  transform: translateX(3px);
}

.logout-link:hover i {
  color: #dc2626 !important;
}

/* =====================================================
   MAIN
===================================================== */

.mn2 {
  flex: 1;
  min-width: 0;
  width: 100%;
}

/* =====================================================
   TOP BAR
===================================================== */

.tb {
  width: 100%;

  display: flex;
  align-items: center;
  gap: 16px;

  margin-bottom: 22px;
  margin-top: 20px;

  padding: 18px 24px;

  background: var(--c);
  border: 1px solid var(--bd);
  border-radius: 16px;

  box-shadow: var(--sh);
}

.mb {
  display: none;

  width: 42px;
  height: 42px;

  flex-shrink: 0;

  align-items: center;
  justify-content: center;

  background: linear-gradient(
    135deg,
    var(--b),
    var(--p)
  );

  border: none;
  border-radius: 11px;

  color: #fff;
  cursor: pointer;
}

.tt {
  flex: 1;
  min-width: 0;
}

.tt h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
}

.tt p {
  margin: 4px 0 0;
  color: var(--mu);
  font-size: 13px;
}

.ta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.ib {
  position: relative;

  width: 42px;
  height: 42px;

  background: #f8fafc;
  border: 1px solid var(--bd);
  border-radius: 11px;

  color: var(--tx);
  cursor: pointer;
}

.ib:hover {
  background: #eef2ff;
  color: var(--b);
}

.dt {
  position: absolute;
  top: 9px;
  right: 10px;

  width: 8px;
  height: 8px;

  border-radius: 50%;

  background: var(--r);
  border: 2px solid var(--c);
}

.as {
  width: 42px;
  height: 42px;

  flex-shrink: 0;

  border-radius: 50%;

  background: linear-gradient(
    135deg,
    var(--b),
    var(--p)
  );

  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 800;
}

/* =====================================================
   DETAILS
===================================================== */

.dc {
  width: 100%;

  background: var(--c);
  border: 1px solid var(--bd);
  border-radius: 16px;

  box-shadow: var(--sh);

  padding: 24px;
}

.dh {
  display: flex;
  justify-content: space-between;
  align-items: center;

  gap: 16px;

  flex-wrap: wrap;

  margin-bottom: 22px;
}

.dh h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
}

.dh p {
  margin: 4px 0 0;
  color: var(--mu);
  font-size: 12.5px;
}

.da {
  display: flex;
  gap: 8px;
}

.bc,
.bs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  padding: 9px 16px;

  border-radius: 10px;

  font-size: 13px;
  font-weight: 700;

  cursor: pointer;
}

.bc {
  background: #f8fafc;
  color: var(--tx);
  border: 1px solid var(--bd);
}

.bc:hover {
  background: #fee2e2;
  color: #b91c1c;
}

.bs {
  border: none;
  background: linear-gradient(
    135deg,
    var(--b),
    var(--p)
  );

  color: #fff;
}

/* =====================================================
   GRID
===================================================== */

.gd {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.fld {
  min-width: 0;

  display: flex;
  align-items: flex-start;

  gap: 12px;

  padding: 16px 18px;

  border: 1px solid var(--bd);
  border-radius: 12px;

  background: #f8fafc;

  transition: all .25s ease;
}

.fld:hover {
  transform: translateY(-4px);
  border-color: var(--b);
  background: #fff;

  box-shadow: 0 10px 22px rgba(37, 99, 235, .12);
}

.fi {
  width: 36px;
  height: 36px;

  flex: 0 0 36px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  background: #eef2ff;
  color: var(--b);

  font-size: 14px;
}

.fb {
  flex: 1;
  min-width: 0;
}

.fb label {
  display: block;

  margin-bottom: 5px;

  color: var(--mu);

  font-size: 11px;
  font-weight: 700;

  text-transform: uppercase;
  letter-spacing: .5px;
}

.fb p {
  margin: 0;

  font-size: 14.5px;
  font-weight: 600;

  overflow-wrap: anywhere;
  word-break: break-word;
}

.fip {
  width: 100%;
  max-width: 100%;

  height: 34px;

  padding: 0 10px;

  border: 1px solid var(--bd);
  border-radius: 8px;

  font-size: 13.5px;
  color: var(--tx);

  outline: none;
}

.fip:focus {
  border-color: var(--b);

  box-shadow: 0 0 0 3px rgba(37, 99, 235, .10);
}

/* =====================================================
   DIVIDER
===================================================== */

.cd {
  height: 2px;

  margin: 24px 0 20px;

  background: linear-gradient(
    90deg,
    transparent,
    var(--r),
    transparent
  );

  border-radius: 20px;
  opacity: .7;
}

/* =====================================================
   EXTRA
===================================================== */

.ex {
  display: grid;
  gap: 12px;
}

.e {
  display: flex;
  align-items: center;

  gap: 14px;

  padding: 14px 16px;

  border: 1px solid var(--bd);
  border-radius: 12px;

  background: #f8fafc;

  transition: .25s;
}

.e:hover {
  transform: translateY(-3px);

  box-shadow: 0 8px 20px rgba(37, 99, 235, .08);
}

.e > .fa {
  width: 40px;
  height: 40px;

  flex: 0 0 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10px;

  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, .10),
    rgba(124, 58, 237, .08)
  );

  color: var(--b);
  font-size: 16px;
}

.e > div {
  flex: 1;
  min-width: 0;
}

.e strong {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

.e small {
  font-size: 12px;
  color: var(--mu);
}

.mib {
  padding: 8px 16px;

  border: 1px solid var(--bd);

  background: var(--c);
  color: var(--tx);

  font-size: 12.5px;
  font-weight: 700;

  border-radius: 9px;

  cursor: pointer;

  white-space: nowrap;
}

.mib:hover {
  background: linear-gradient(
    135deg,
    var(--b),
    var(--p)
  );

  color: #fff;
  border-color: transparent;
}

/* =====================================================
   OVERLAY
===================================================== */

.ov {
  position: fixed;
  inset: 0;

  background: rgba(1, 11, 23, .55);

  z-index: 998;
}

/* =====================================================
   DARK MODE EXTRAS
===================================================== */

.dk .mn a:hover {
  background: #1a2438;
}

.dk .mn a i {
  color: #94a3b8;
}

.dk .mn a.active {
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, .22),
    rgba(124, 58, 237, .18)
  );
  border-color: rgba(37, 99, 235, .35);
  color: #93c5fd;
}

.dk .ib {
  background: #1a2438;
  border-color: var(--bd);
  color: #cbd5e1;
}

.dk .ib:hover {
  background: #22304a;
  color: #93c5fd;
}

.dk .dt {
  border-color: var(--c);
}

.dk .fld,
.dk .e {
  background: #1a2438;
}

.dk .fld:hover,
.dk .e:hover {
  background: #22304a;
  border-color: var(--b);
}

.dk .fi {
  background: rgba(37, 99, 235, .18);
  color: #93c5fd;
}

.dk .bc {
  background: #1a2438;
  color: #e2e8f0;
}

.dk .bc:hover {
  background: #3b1d1d;
  color: #fca5a5;
}

.dk .fip {
  background: #0f172a;
  color: #e2e8f0;
  border-color: var(--bd);
}

.dk .fip:focus {
  border-color: var(--b);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, .25);
}

.dk .mib {
  background: #1a2438;
  color: #e2e8f0;
}

.dk .ov {
  background: rgba(0, 0, 0, .7);
}

/* Dark mode logout */
.dk .logout-link {
  color: #f87171 !important;
}

.dk .logout-link i {
  color: #f87171 !important;
}

.dk .logout-link:hover {
  background: rgba(248, 113, 113, .15) !important;
  color: #fca5a5 !important;
}

.dk .logout-link:hover i {
  color: #fca5a5 !important;
}

/* Smooth transitions */
.pw,
.sb,
.tb,
.dc,
.fld,
.e,
.ib,
.bc,
.mib,
.fip {
  transition: background .3s ease, color .3s ease, border-color .3s ease;
}

/* =====================================================
   TABLET
===================================================== */

@media (max-width: 1199px) {
  .lay {
    padding: 18px;
    gap: 18px;
  }

  .sb {
    width: 220px;
    min-width: 220px;
    flex-basis: 220px;
  }

  .tb {
    padding: 16px 18px;
  }

  .tt h1 {
    font-size: 20px;
  }

  .dc {
    padding: 20px;
  }
}

/* =====================================================
   MOBILE SIDEBAR
===================================================== */

@media (max-width: 991px) {
  .lay {
    display: block;
    width: 100%;
    padding: 14px;
    margin-top: 88px;
  }

  .mn2 {
    width: 100%;
  }

  .sb {
    position: fixed;

    top: 0;
    left: 0;
    margin-top: 70px;
    width: 270px;
    max-width: 85vw;
    height: 100vh;

    padding: 16px 12px;

    border-radius: 0;

    transform: translateX(-110%);

    transition: transform .3s ease;

    z-index: 9999;

    overflow-y: auto;
  }

  .sb.open {
    transform: translateX(0);
  }

  .mb {
    display: flex;
  }

  .tb {
    margin-top: 10px;
    margin-bottom: 16px;

    padding: 14px 16px;

    gap: 12px;
  }

  .dc {
    width: 100%;
    padding: 18px;
  }
}

/* =====================================================
   MOBILE
===================================================== */

@media (max-width: 768px) {
  .lay {
    padding: 10px;
  }

  .tb {
    padding: 12px;
    border-radius: 12px;
  }

  .mb {
    width: 40px;
    height: 40px;
  }

  .tt h1 {
    font-size: 17px;
  }

  .tt p {
    font-size: 11px;
  }

  .ta {
    gap: 7px;
  }

  .ib,
  .as {
    width: 38px;
    height: 38px;
  }

  .dc {
    padding: 14px;
    border-radius: 12px;
  }

  .dh {
    flex-direction: column;
    align-items: flex-start;

    gap: 12px;

    margin-bottom: 16px;
  }

  .dh h3 {
    font-size: 16px;
  }

  .da {
    width: 100%;
  }

  .bc,
  .bs {
    flex: 1;
  }

  .gd {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .fld,
  .fld[style*="span 2"] {
    grid-column: span 1 !important;
    width: 100%;
  }

  .fld {
    padding: 13px;
  }

  .fb p {
    font-size: 13px;
  }

  .fb label {
    font-size: 10px;
  }

  .e {
    padding: 12px;
    gap: 10px;
  }

  .e > .fa {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }

  .e strong {
    font-size: 13px;
  }

  .e small {
    font-size: 11px;
  }
}

/* =====================================================
   SMALL MOBILE
===================================================== */

@media (max-width: 480px) {
  .lay {
    padding: 8px;
  }

  .tb {
    padding: 10px;
    gap: 9px;

    margin-top: 6px;
  }

  .mb {
    width: 38px;
    height: 38px;
  }

  .tt h1 {
    font-size: 16px;
  }

  .tt p {
    display: none;
  }

  .ta {
    gap: 5px;
  }

  .ib,
  .as {
    width: 36px;
    height: 36px;
  }

  .dc {
    padding: 12px;
  }

  .dh h3 {
    font-size: 15px;
  }

  .dh p {
    font-size: 11px;
  }

  .da {
    gap: 6px;
  }

  .bc,
  .bs {
    padding: 8px;
    font-size: 12px;
  }

  .fld {
    padding: 11px;
    gap: 9px;
  }

  .fi {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
    font-size: 12px;
  }

  .fb label {
    font-size: 9px;
  }

  .fb p {
    font-size: 12px;
  }

  .e {
    flex-wrap: wrap;
  }

  .e > div {
    min-width: 0;
  }

  .mib {
    width: 100%;
    margin-top: 3px;
  }
}

/* =====================================================
   VERY SMALL MOBILE
===================================================== */

@media (max-width: 360px) {
  .lay {
    padding: 6px;
  }

  .tb {
    padding: 8px;
  }

  .tt h1 {
    font-size: 15px;
  }

  .dc {
    padding: 10px;
  }

  .fld {
    padding: 10px;
  }

  .fb p {
    font-size: 11px;
  }
}

      `}</style>

      <div className={`pw ${dark ? "dk" : ""}`}>

        {open && (
          <div className="ov" onClick={() => setOpen(false)} />
        )}

        <div className="lay">

          {/* SIDEBAR */}
          <aside className={`sb ${open ? "open" : ""}`}>

            <div className="br">
              <span className="bi">
                <i className="fa fa-graduation-cap" />
              </span>

              <div>
                <small>STUDENT SCHOOL</small>
                <strong>DARPAN</strong>
              </div>
            </div>

            <ul className="mn">

              {MENU.map(([to, ic, nm, cls]) => (
                <li key={nm}>
                  <Link
                    to={to}
                    className={cls}
                    onClick={() => setOpen(false)}
                  >
                    <i className={`fa ${ic}`} />
                    {nm}
                  </Link>
                </li>
              ))}

              {/* Red Separator */}
              <li className="dv" />

              {/* Logout */}
              <li>
                <Link
                  to="/"
                  className="logout-link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLogout();
                  }}
                >
                  <i className="fa fa-sign-out" />
                  Logout
                </Link>
              </li>

            </ul>
          </aside>

          {/* MAIN */}
          <main className="mn2">

            <header className="tb">

              <button
                className="mb"
                onClick={() => setOpen(true)}
                aria-label="Open Menu"
              >
                <i className="fa fa-bars" />
              </button>

              <div className="tt">
                <h1>My Profile</h1>
                <p>Manage your personal information</p>
              </div>

              <div className="ta">

                {/* 🌙 DARK MODE TOGGLE */}
                {/* <button
                  className="ib"
                  onClick={toggleDark}
                  title={dark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                >
                  <i className={`fa ${dark ? "fa-sun-o" : "fa-moon-o"}`} />
                </button> */}

                <button className="ib">
                  <i className="fa fa-bell" />
                  <span className="dt" />
                </button>

                <div className="as">{p.name[0]}</div>

              </div>

            </header>

            <section className="dc">

              <div className="dh">

                <div>
                  <h3>Personal Information</h3>
                  <p>Your account details</p>
                </div>

                <div className="da">

                  {!edit ? (
                    <button
                      className="bs"
                      onClick={() => setEdit(true)}
                    >
                      <i className="fa fa-pencil" />
                      Edit Profile
                    </button>
                  ) : (
                    <>
                      <button className="bc" onClick={cancel}>
                        <i className="fa fa-times" />
                        Cancel
                      </button>

                      <button className="bs" onClick={save}>
                        <i className="fa fa-check" />
                        Save
                      </button>
                    </>
                  )}

                </div>

              </div>

              <div className="gd">

                <F i="fa-user" l="Name" n="name" v={t.name} />

                <F i="fa-envelope-o" l="Email" n="email" v={t.email} />

                <F i="fa-phone" l="Phone" n="phone" v={t.phone} />

                <F i="fa-shield" l="Role" n="role" v={t.role} />

                <F
                  i="fa-building-o"
                  l="School"
                  n="school"
                  v={t.school}
                  full
                />

                <F i="fa-map-marker" l="City" n="city" v={t.city} />

                <F
                  i="fa-calendar"
                  l="Joining"
                  n="joiningDate"
                  v={t.joiningDate}
                  dis
                />

              </div>

              <div className="cd" />

              <div className="ex">

                <div className="e">
                  <i className="fa fa-lock" />

                  <div>
                    <strong>Change Password</strong>
                    <small>Update your password</small>
                  </div>

                  <button className="mib">Update</button>
                </div>

              </div>

            </section>

          </main>

        </div>

      </div>
    </>
  );
}